import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const generateWithTrackingParams = (
  query: Record<string, string | string[] | undefined>,
  extraParams?: Record<string, string | null | undefined>,
) => {
  const params = new URLSearchParams();

  // Preserve all existing query params except "handle"
  Object.entries(query).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    const normalizedKey = key.toLowerCase();
    const isHandle = normalizedKey === 'handle';
    const isBracketKey = key.includes('[');

    if (!isHandle && !isBracketKey) {
      // We need to exclude Array Parameters as they keep appending instead of replacing
      params.set(key, Array.isArray(value) ? value[0] : value);
    }
  });

  // Append additional params
  if (extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      if (value != null) {
        params.set(key, value);
      }
    });
  }

  return params;
};

const useStreamlineUrl = ({
  productId,
  skuId,
}: {
  productId: string;
  skuId: string | null;
}) => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const currentSkuId = router.query?.skuId;

    if (!skuId || currentSkuId === skuId || !currentSkuId) {
      return;
    }

    const querParams = generateWithTrackingParams(router.query, {
      skuId,
    }).toString();

    // --- Final cleaned URL
    const finalUrl = `/collections/${encodeURIComponent(
      productId,
    )}?${querParams}`;

    router.replace(finalUrl, undefined, { shallow: true });
  }, [router.isReady, skuId]);
};

export default useStreamlineUrl;
